import React from "react";

const HealthcareSection = () => {
  return (
    <section
      style={{
        minHeight: "90vh",
        paddingTop: "7rem",
        paddingBottom: "4rem",
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.7s ease-out",
        opacity: 1,
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "3rem",
        }}
      >
        <div style={{ flex: 1, textAlign: "center" }}>
          <div
            style={{
              display: "inline-block",
              padding: "0.5rem 1rem",
              backgroundColor: "#DFF1FE",
              color: "#0568A0",
              borderRadius: "9999px",
              fontSize: "0.875rem",
              fontWeight: "500",
            }}
          >
            Advanced Healthcare Solutions
          </div>
          <h1
            style={{
              fontSize: "2.5rem",
              fontWeight: "bold",
              lineHeight: "1.2",
              marginTop: "1rem",
            }}
          >
            Your health journey, <br />
            <span style={{ color: "#0BA5E9" }}>simplified</span> and personalized
          </h1>
          <p
            style={{
              fontSize: "1.125rem",
              color: "#6B7280",
              maxWidth: "600px",
              margin: "1rem auto 0",
            }}
          >
            Tell us about your symptoms and we'll connect you with the right
            specialists for personalized care that puts your needs first.
          </p>
        </div>

        <div style={{ display: "flex", gap: "1rem" }}>
          <button
            style={{
              backgroundColor: "#0055A4",
              color: "#fff",
              padding: "1rem 2rem",
              borderRadius: "0.75rem",
              fontSize: "1.125rem",
              fontWeight: "500",
              border: "none",
              cursor: "pointer",
            }}
          >
            Get Started
          </button>
          <button
            style={{
              backgroundColor: "#fff",
              color: "#0055A4",
              border: "2px solid #0055A4",
              padding: "1rem 2rem",
              borderRadius: "0.75rem",
              fontSize: "1.125rem",
              fontWeight: "500",
              cursor: "pointer",
            }}
          >
            Learn More
          </button>
        </div>
      </div>
    </section>
  );
};

export default HealthcareSection;
